var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-2"},[_c('v-row',{staticClass:"v-flex flex-row mt-6 mb-10"},_vm._l((_vm.references),function(item,idx){return _c('v-col',{key:idx,attrs:{"lg":"4"}},[_c('InfoCard',{attrs:{"cardData":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }